<ng-container *ngIf="internal; else externalAnchor">
    <a finderLinkId
        [attr.id]="id"
        [attr.aria-label]="ariaLabel"
        [attr.aria-pressed]="ariaPressed"
        [attr.role]="role"
        [routerLink]="href"
        [title]="title"
        [target]="target"
        [attr.tabindex]="tabIndex"
        [linkId]="linkId"
        class="anchor">
        <ng-container *ngTemplateOutlet="label"></ng-container>
    </a>
</ng-container>
<ng-template #externalAnchor>
    <a finderLocale
        finderLinkId
        finderRouterLink
        [attr.id]="id"
        [attr.aria-current]="ariaCurrent"
        [attr.aria-label]="ariaLabel"
        [href]="href"
        [title]="title"
        [target]="target"
        [attr.tabindex]="tabIndex"
        [linkId]="linkId"
        class="anchor"
        [ngClass]="{'allow-tracking': allowTracking === true}">
        <ng-container *ngTemplateOutlet="label"></ng-container>
    </a>
</ng-template>
<ng-template #label>
    <ng-content></ng-content>
</ng-template>
